import { createContext, useState, Children, createRef, MutableRefObject } from "react";
import { OptionalRefObject } from "src/types";

export const StepperContext = createContext({
  step: 0,
  steps: 0,
  nextStep: () => {},
  prevStep: () => {},
  cancel: () => {},
});

interface StepperProps {
  children: React.ReactNode[];
  stepRefs?: MutableRefObject<OptionalRefObject[]>;
  cancel?: () => void;
}

export function Stepper({ children, cancel, stepRefs }: StepperProps) {
  const [step, setStep] = useState(0);

  const stepCount = Children.toArray(children).length;
  const styles = { transform: `translateX(${(stepCount - step - stepCount) * 100}%)`, transition: "transform 500ms" };

  const stepActions = {
    step,
    steps: stepCount,
    nextStep: () => setStep((step) => Math.min(Children.count(children), step + 1)),
    prevStep: () => setStep((step) => Math.max(0, step - 1)),
    cancel: cancel ? cancel : () => {},
  };

  return (
    <StepperContext.Provider value={stepActions}>
      <div className="relative flex w-[375px] max-w-full" style={styles}>
        {Children.toArray(children).map((child, index) => {
          return (
            <div
              key={index}
              aria-hidden={step !== index}
              ref={(el) => {
                if (stepRefs) {
                  stepRefs.current[index] = createRef();
                  stepRefs.current[index].current = el;
                }
              }}
              className="flex flex-col flex-shrink-0 justify-between w-full h-full p-4 bg-white border border-gray-100"
            >
              {child}
            </div>
          );
        })}
      </div>
    </StepperContext.Provider>
  );
}
